import { useContext } from 'react';

import DealerRequestModalContext from './dealerRequestModal.context';

function useDealerRequestModal() {
  const context = useContext(DealerRequestModalContext);

  if (!context) {
    throw new Error('useDealerRequestModal must be used within DealerRequestModalContext');
  }

  return context;
}

export default useDealerRequestModal;